import {
  RecordRequestPayload,
  recordRequestPayloadSchema,
} from "../request-records/schema";
import { fetchData, setHeaderOptions } from "./apiHelpers";

export type RecordRequestResponse = {
  id?: string;
  status?: string;
};

// Authenticated create. Uses setHeaderOptions to include Supabase tokens.
export async function createRecordRequestAuthed(payload: RecordRequestPayload) {
  const parsed = recordRequestPayloadSchema.parse(payload);
  const request = setHeaderOptions({ method: "POST", body: parsed });
  // Relative path so fetchData adds REACT_APP_API_URL
  return fetchData<RecordRequestResponse>(
    "/record-requests",
    request as RequestInit
  );
}
